import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';

export const downloadTrainingsExcel = async (downloadData) => {
  const workbook = new ExcelJS.Workbook();

  const worksheet = workbook.addWorksheet(
    downloadData.sheetName || 'Training Report'
  );

  // =========================
  // SAFE VALUE FUNCTION
  // =========================
  const getValue = (value) => {
    return value !== null &&
      value !== undefined &&
      value !== ''
      ? value
      : '--';
  };

  // =========================
  // HEADERS
  // =========================
  const baseHeaders = downloadData.columns || [
    { header: 'S.NO', key: 'sno' },
    { header: 'TRAINEE NAME', key: 'trainee_name' },
    { header: 'DEPARTMENT', key: 'department_name' },
    { header: 'TRAINER(S)', key: 'trainers' },
    { header: 'ATTENDANCE %', key: 'attendance_percentage_display' },
    { header: 'AVG FEEDBACK', key: 'rating_display' },
  ];

  worksheet.columns = baseHeaders;

  // =========================
  // DATA INSERT
  // =========================
  downloadData.data.forEach((item, index) => {
    worksheet.addRow({
      sno: index + 1,

      trainee_name: getValue(item.trainee_name),

      department_name: getValue(item.department_name),

      trainers: getValue(item.trainers),

      attendance_percentage_display:
        item.attendance_percentage !== null &&
        item.attendance_percentage !== undefined &&
        item.attendance_percentage !== ''
          ? `${item.attendance_percentage}%`
          : '--',

      rating_display:
        item.rating !== null &&
        item.rating !== undefined &&
        item.rating !== ''
          ? `${item.rating} / 5`
          : '--',
    });
  });

  // =========================
  // HEADER STYLE
  // =========================
  const headerRow = worksheet.getRow(1);

  headerRow.height = 35;

  headerRow.eachCell((cell) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '1F4E78' },
    };

    cell.font = {
      name: 'Times New Roman',
      bold: true,
      size: 12,
      color: { argb: 'FFFFFF' },
    };

    cell.alignment = {
      horizontal: 'center',
      vertical: 'middle',
      wrapText: true,
    };

    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  // =========================
  // BODY STYLE
  // =========================
  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber > 1) {
      row.height = 25;

      row.eachCell((cell) => {
        cell.font = {
          name: 'Times New Roman',
          size: 11,
        };

        cell.alignment = {
          horizontal: 'center',
          vertical: 'middle',
          wrapText: true,
        };

        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    }
  });

  // =========================
  // AUTO COLUMN WIDTH
  // =========================
  worksheet.columns.forEach((column) => {
    let maxLength = 10;

    column.eachCell({ includeEmpty: true }, (cell) => {
      const value = cell.value ? cell.value.toString() : '--';

      maxLength = Math.max(maxLength, value.length);
    });

    column.width = Math.min(maxLength + 5, 40);
  });

  // =========================
  // EXPORT
  // =========================
  const buffer = await workbook.xlsx.writeBuffer();

  saveAs(
    new Blob([buffer]),
    downloadData.fileName || 'Training_Report.xlsx'
  );
};